import type { RefObject } from 'react';
import { useEffect } from 'react';
import { isPassiveSupport } from '@utilities/passiveSupport';

export function useClickOutside<T extends RefObject<HTMLElement>>(
  refs: ReadonlyArray<T>,
  handler: (event: MouseEvent | TouchEvent) => void
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const clickedOutside = refs.every((ref) => {
        if (
          !ref.current ||
          (typeof ref.current['contains'] === 'function' &&
            ref.current.contains(event.target as Node))
        ) {
          return false;
        }
        return true;
      });
      if (!clickedOutside) return;
      handler(event);
    };
    const options = isPassiveSupport() ? { passive: true } : false;
    document.addEventListener('mousedown', listener, options);
    document.addEventListener('touchstart', listener, options);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [refs, handler]);
}
